export default function () {
  return [
            [
          'a',
          'STATUS',
          ':',
          'OK?',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'tx-State',
          ':',
          '-',
          '',
          'pa-State',
          ':',
          '-',
          '',
          'sa-State',
          ':',
          '-',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'b',
          'RATES',
          ':',
          'DEAL?',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'tx-State',
          ':',
          '-',
          '',
          'pb-State',
          ':',
          '-',
          '',
          'sb-State',
          ':',
          '-',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'c',
          'DOCS',
          ':',
          'TERMS?',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'tx-State',
          ':',
          '-',
          '',
          'pc-State',
          ':',
          '-',
          '',
          'sc-State',
          ':',
          '-',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'd',
          'BOOK',
          ':',
          'BOOKED?',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'tx-State',
          ':',
          '-',
          '',
          'pd-State',
          ':',
          '-',
          '',
          'sd-State',
          ':',
          '-',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'e',
          'INPUT',
          ':',
          'CREATED?',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'tx-State',
          ':',
          '-',
          '',
          'pe-State',
          ':',
          '-',
          '',
          'se-State',
          ':',
          '-',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'f',
          'STEPS',
          ':',
          'PLANNED?',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'tx-State',
          ':',
          '-',
          '',
          'pf-State',
          ':',
          '-',
          '',
          'sf-State',
          ':',
          '-',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'g',
          'OUTPUT',
          ':',
          'TESTED?',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'tx-State',
          ':',
          '-',
          '',
          'pg-State',
          ':',
          '-',
          '',
          'sg-State',
          ':',
          '-',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          'h',
          'PAY',
          ':',
          'PAID?',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],
        [
          '1',
          'tx-State',
          ':',
          '-',
          '',
          'ph-State',
          ':',
          '-',
          '',
          'sh-State',
          ':',
          '-',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
        ],

  ]
}